class RootStore {
    constructor(stores) {
        Object.keys(stores).forEach(key => {
            this[key] = new stores[key](this)
        })
    }
}

export default RootStore
